// import React from 'react'
import { AddToList } from '../add-to-list';

import { useTranslation } from 'react-i18next';
interface IProp {
  gridApi?: any;
  currentUrl: string;
  numberOfSelected: number;
  isCompareProducts?: boolean;
  isAddToList?: boolean;
  isReverse: boolean;
  compareProductsBtnHandler?: () => void;
}

const ActionWhenSelectPart: React.FC<IProp> = ({
  gridApi,
  currentUrl,
  numberOfSelected,
  isCompareProducts,
  isAddToList,
  isReverse,
  compareProductsBtnHandler
}) => {
  const { t } = useTranslation();

  return (
    <div className="selected-buttons-wrapper">
      <div className="selected-buttons-content">
        <div className="selected-buttons-floater">
          <div
            className={isCompareProducts ? 'selected compare-button' : ''}
            id="compare-button"
            data-testid="compareButton"
          >
            {isCompareProducts && (
              <div>
                <button
                  className="dk-btn__primary"
                  onClick={compareProductsBtnHandler}
                  id="compare-btn"
                  data-testid="compare-btn"
                  {...{
                    ref_page_event: 'Click Compare Products'
                  }}
                >
                  {t('xref-introduction-compare')} {numberOfSelected}{' '}
                  {t('xref-products')}
                </button>
              </div>
            )}
          </div>

          <div
            className={isAddToList ? 'selected add-to-list-container' : ''}
            id="add-to-list-container"
          >
            {isAddToList && (
              <AddToList
                numberOfSelected={numberOfSelected}
                currentUrlToRedirect={currentUrl}
                gridApi={gridApi}
                isReverse={isReverse}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionWhenSelectPart;
